import * as types from './types'

export function setCases(cases){
  return {
    type: types.SET_CASES,
    payload:cases
  }
}

export function setCurrentCase(curCase){
  return {
    type: types.SET_CURRENT_CASE,
    payload:curCase
  }
}

export function setCurrentSelection(selection){
  return {
    type: types.SET_CURRENT_SELECTION,
    payload:selection
  }
}



// WEBPACK FOOTER //
// ./src/actions/cases.js